export function picString(index) {
  // 生成一个20位的图片名称——前面8位为年月日，后面12位为时间戳
  const data = new Date()
  let year = data.getFullYear()
  const min = 1000
  const max = 9999
  let rand = Math.floor(Math.random() * (max - min + 1)) + min
  let month = (data.getMonth() + 1).toString().padStart(2, '0')
  let day = data.getDate().toString().padStart(2, '0')
  let timestamp = data.getTime().toString()
  let times = timestamp.slice(-8) //截取后8位时间戳
  let str = `${year}${month}${day}${rand}${times}`
  let name = str.substring(0, index)


  return name
}